import { SxProps } from '@mui/system'
import { theme } from 'src/providers/ThemeProvider'

type fieldsGroupElements = {
  fieldset: SxProps
  legend: SxProps
  buttonsContainer: SxProps
}

export const fieldGroupStyles: fieldsGroupElements = {
  fieldset: {
    display: 'flex',
    flexDirection: 'column',
    width: 'auto',
    backgroundColor: theme.corporate.secondaryColor,
    marginBottom: '16px',
    padding: '0 20px',
    borderWidth: 1,
    borderColor: theme.corporate.primaryColor,
    borderTopWidth: 4,
    borderTopColor: theme.colors.blue04,
    borderStyle: 'solid',
    '&.secondary-type': {
      borderTopWidth: 1,
      borderColor: theme.colors.blue04,
      padding: '16px',
      '& ~ .secondary-type': {
        marginTop: '10px',
        marginBottom: '24px'
      },
      '& legend': {
        minWidth: 'calc(350px - 10px)',
        fontSize: '12px',
        color: theme.corporate.primaryColor,
        backgroundColor: theme.colors.blue07,
        borderWidth: 0,
        '& .MuiBox-root': {
          borderColor: theme.colors.blue07
        }
      }
    },
    '&.has-buttons': {
      marginTop: '26px',
      paddingTop: '24px',
      '&.remitente': {
        marginTop: '16px'
      }
    },
    '& .MuiButton-root': {
      alignSelf: 'flex-end'
    },
    '& .required-fieldset .legend-text:after': {
      position: 'absolute',
      top: 0,
      content: '"*"',
      fontSize: '18px',
      color: theme.colors.red01,
      marginLeft: '3px'
    }
  },
  legend: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    position: 'relative',
    minWidth: '350px',
    maxWidth: '100%',
    minHeight: '30px',
    fontFamily: theme.corporate.secondaryFont,
    fontSize: '14px',
    color: theme.corporate.secondaryColor,
    textTransform: 'uppercase',
    backgroundColor: theme.corporate.primaryColor,
    padding: '2px 10px',
    borderWidth: 1,
    borderColor: theme.corporate.primaryColor,
    borderStyle: 'solid',
    '& .MuiBox-root': {
      borderColor: theme.corporate.primaryColor
    }
  },
  buttonsContainer: {
    display: 'flex',
    alignItems: 'center',
    height: '56px',
    position: 'absolute',
    left: 'calc(100% - 10px)',
    backgroundColor: theme.corporate.secondaryColor,
    borderWidth: 4,
    borderStyle: 'solid',
    borderRadius: 50,
    padding: '0 5px',
    '& .MuiButtonBase-root': {
      height: '35px',
      width: '35px',
      borderWidth: 4,
      borderStyle: 'solid',
      borderColor: 'transparent',
      boxSizing: 'content-box',
      backgroundClip: 'padding-box',
      padding: 0,
      '&:hover': {
        borderColor: theme.colors.blue06
      },
      '&.Mui-disabled': {
        backgroundColor: theme.colors.blue06,
        '& .MuiSvgIcon-root': {
          backgroundColor: theme.colors.blue06
        }
      }
    },
    '& .MuiIconButton-root': {
      backgroundColor: theme.corporate.primaryColor,
      '&:hover': {
        backgroundColor: theme.corporate.primaryColor
      }
    },
    '& .MuiSvgIcon-root': {
      fontSize: '21px',
      color: theme.corporate.secondaryColor,
      backgroundColor: theme.corporate.primaryColor
    }
  }
}
